<template>
  <div class="container auth-page">
    <div class="row">
      <div class="col-xs-12 col-md-8">
        <div class="panel panel-default">
          <div class="panel-heading"><strong>Register</strong></div>
          <div class="panel-body">
            <template v-if="product">
              <div class="row">
                <h2 class="col-md-10">{{ product.name }}</h2>
                <div class="col-md-2" v-if="product.custom_view.additional_logo">
                  <img class="img img-thumbnail" :src="product.custom_view.additional_logo">
                </div>
              </div>

              <template v-if="product.addons && product.addons.length > 0">
                <h3>Available Addons:</h3>
                <div class="addon-products">
                  <div v-for="addon in product.addons" :key="addon.id">
                    <addon-product
                        :product="addon"
                        @toggleAddon="toggleAddon($event, addon)"
                    ></addon-product>
                  </div>
                </div>
              </template>
            </template>
            <div class="cell form-wrapper">
              <Form v-slot="{ handleSubmit}" :validation-schema="schema" as="div">
                <form
                  class="form-horizontal sign-up-form"
                  role="form"
                  id="sign-up-form"
                  @submit="handleSubmit($event, register)"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <h3>Your Details:</h3>

                      <div class="form-group">
                        <div class="col-sm-6 form-group no-marg">
                          <label class="control-label">Your First Name</label>
                          <Field type="text" class="form-control" name="first_name" v-model="user.first_name" placeholder="Your First Name"/>
                          <ErrorMessage class="error_message" name="first_name" />
                        </div>

                        <div class="col-sm-6 form-group no-marg">
                          <label class="control-label">Your Last Name</label>
                          <Field type="text" class="form-control" name="last_name" v-model="user.last_name" placeholder="Your First Name"/>
                          <ErrorMessage class="error_message" name="last_name" />
                        </div>

                        <div class="col-sm-12 form-group no-marg">
                          <label class="control-label">Your Company Name</label>
                          <Field type="text" class="form-control" name="company_name" label="Company Name" v-model="user.company_name" placeholder="Your Company Name"/>
                          <ErrorMessage class="error_message" name="company_name" />
                        </div>

                        <div class="col-sm-12 form-group no-marg">
                          <label class="control-label">E-Mail Address</label>
                          <Field type="text" class="form-control" name="email" v-model="user.email" placeholder="E-Mail Address"/>
                          <ErrorMessage class="error_message" name="email" />
                        </div>

                        <div class="col-sm-6 form-group no-marg">
                          <label class="control-label">Password</label>
                          <Field type="password" class="form-control" name="password" v-model="user.password" placeholder="Password"/>
                          <ErrorMessage class="error_message" name="password" />
                        </div>

                        <div class="col-sm-6 form-group no-marg">
                          <label class="control-label">Confirm Password</label>
                          <Field type="password" class="form-control" name="password_confirmation" v-model="user.password_confirmation" placeholder="Confirm Passwor"/>
                          <ErrorMessage class="error_message" name="password_confirmation" />
                        </div>
                      </div>
                      <template v-if="product">
                        <payment-form
                            :product="product"
                            :addonProducts="Object.values(addonProducts)"
                            :user="user"
                            :mode="'create'"
                            :couponCode="coupon"
                            :networkKey="networkKey"
                            ref="payment_form"
                            @couponApplied="onCouponApplied"
                        ></payment-form>
                      </template>
                    </div>
                  </div>
                </form>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <!--    @if($type != 'lite' && $type != 'financial-ratios')-->
      <div class="col-xs-12 col-md-4">
        <div class="panel panel-default sidebar">
          <div class="panel-heading"><strong>Subscription Summary</strong></div>
          <div class="panel-body">
            <div v-if="product" class="subscription-summary">
              <div class="summary-item">
                <div class="summary-item-title"><strong>{{ product.name }}</strong></div>
                <div class="summary-item-price"><strong>{{ prices.main }}</strong></div>
              </div>
              <div class="summary-item" v-if="product.addons && product.addons.length > 0">
                <div class="summary-item-title">Addons</div>
                <div class="summary-item-price">{{ prices.addons }}</div>
              </div>
              <div class="summary-delimiter"></div>
              <div class="summary-item">
                <div class="summary-item-title">Subtotal</div>
                <div class="summary-item-price">{{ prices.subtotal }}</div>
              </div>
              <div class="summary-item">
                <div class="summary-item-title">{{ title_vat }}</div>
                <div class="summary-item-price">{{ prices.vat }}</div>
              </div>
              <div class="summary-delimiter"></div>
              <div class="summary-item">
                <div class="summary-item-title"><strong>Total subscription</strong></div>
                <div class="summary-item-price"><strong>{{ prices.total }}</strong></div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel panel-default sidebar">
          <div class="panel-heading">
            <strong
            >By purchasing your MO license today you will gain the
              following:</strong
            >
          </div>
          <div class="panel-body">
            <ul>
              <li>
                <strong :style="product.slug === 'trial_cda' ? { color: '#b0b0b0' } : {}">
                  Your Focus: Compliance, risk and Management Information
                  (MI).
                </strong>
                <ul>
                  <li :style="product.slug === 'trial_cda' ? { color: '#b0b0b0' } : {}">
                    The ability to scan your business development across key
                    strategies: Compliance, Corporate governance, Risk
                    management and Cyber-risks.
                  </li>
                </ul>
              </li>
              <li>
                <strong :style="product.slug === 'trial_cda' ? { color: '#b0b0b0' } : {}">
                  Your Engagement: Client and stakeholder
                  relationships.
                </strong>
                <ul>
                  <li :style="product.slug === 'trial_cda' ? { color: '#b0b0b0' } : {}">
                    Understand the strength and depth of your client
                    communications and marketing strategies.
                  </li>
                </ul>
              </li>
              <li>
                <strong>
                  Consumer Duty Validation:
                </strong>
                <ul>
                  <li>
                    Ensure your Consumer Duty implementation remains compliant with all FCA requirements
                  </li>
                </ul>
              </li>
              <li>
                <strong :style="product.slug === 'trial_cda' ? { color: '#b0b0b0' } : {}">
                  Your Promise: Centralised investment and service
                  proposition.
                </strong>
                <ul>
                  <li :style="product.slug === 'trial_cda' ? { color: '#b0b0b0' } : {}">
                    Ensure a robust research and due diligence process across
                    the proposition.
                  </li>
                </ul>
              </li>
              <li>
                <strong :style="product.slug === 'trial_cda' ? { color: '#b0b0b0' } : {}">
                  Your Systems: Operations and service supports.
                </strong>
                <ul>
                  <li :style="product.slug === 'trial_cda' ? { color: '#b0b0b0' } : {}">
                    Client relationship management systems focus on opportunity
                    management.
                  </li>
                </ul>
              </li>
              <li>
                <strong :style="product.slug === 'trial_cda' ? { color: '#b0b0b0' } : {}">
                  Your people: Employee engagement and talent
                  development.
                </strong>
                <ul>
                  <li :style="product.slug === 'trial_cda' ? { color: '#b0b0b0' } : {}">
                    Ensure your business has the right people in the right role
                    with the right skills and you identify and retain the right
                    talent.
                  </li>
                </ul>
              </li>
              <li>
                <strong :style="product.slug === 'trial_cda' ? { color: '#b0b0b0' } : {}">
                  Your Performance Dashboard
                </strong>
                <ul>
                  <li :style="product.slug === 'trial_cda' ? { color: '#b0b0b0' } : {}">
                    All the above will be benchmarked against our research into
                    wealth manager and adviser firm professional practice.
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentForm from "./PaymentForm";

export default {
  name: "Register",
  components: {
    "payment-form": PaymentForm,
  },
  props: ["product_id", "tax_rate", "coupon", "networkKey"],
  data() {
    return {
      user: {
        first_name: null,
        last_name: null,
        company_name: null,
        email: null,
        password: null,
        password_confirmation: null,
      },
      title_vat: 'Vat',
      product: null,
      addonProducts: {},
      discount: {
        percent_off: null,
        amount_off: null,
      },
      prices: {
        main: 0,
        addons: 0,
        subtotal: 0,
        vat: 0,
        total: 0,
      },
    };
  },
  computed: {
    schema() {
      return yup.object({
        first_name: yup.string().required().min(3).label('First Name'),
        last_name: yup.string().required().min(3).label('Last Name'),
        company_name: yup.string().required().min(3).label('Company Name'),
        email: yup.string().required().email().label('E-Mail Address'),
        password: yup.string().required().min(6).max(100).label('Password'),
        password_confirmation: yup.string().required().min(6).max(100).oneOf([yup.ref('password'), null], 'Passwords must match').label('Confirm Password'),

      });
    },
  },
  methods: {
    register() {
      this.$refs.payment_form.pay(this.user);
    },
    getProduct() {
      axios
        .get("/products/" + this.product_id)
        .then((res) => {
          this.product = res.data.data;
          this.updatePrice();
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    toggleAddon(selected, product) {
      if (selected) {
        this.addonProducts[product.id] = {
          quantity: 1,
          id: product.id,
          price: product.price
        };
      } else {
        delete this.addonProducts[product.id];
      }
      this.updatePrice();
    },
    onCouponApplied(coupon) {
      this.discount = {
        percent_off: coupon.percent_off ?? null,
        amount_off: coupon.amount_off ?? null,
      };
      this.updatePrice();
    },
    updatePrice() {
      let main = +this.product.price;
      let addons = 0;
      Object.values(this.addonProducts).forEach((item) => {
        addons += item.price;
      });

      if (this.discount.percent_off) {
        const multiplier = 1 - (this.discount.percent_off / 100);
        main *= multiplier;
        addons *= multiplier;
      } else if (this.discount.amount_off) {
        // Stripe amount_off is in the currency's smallest unit (e.g. pence)
        const amountOff = this.discount.amount_off / 100;
        const combined = Math.max(main + addons - amountOff, 0);
        const ratio = (main + addons) > 0 ? combined / (main + addons) : 0;
        main *= ratio;
        addons *= ratio;
      }

      let subtotal = +main + addons;
      let vat = subtotal * this.tax_rate * 0.01;
      let total = subtotal + vat;

      let currency = this.product.currency || 'gbp';
      let locale = 'en-GB';

      if(currency === 'aud') {
        this.title_vat = 'GST'
      }

      var formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
      });

      this.prices = {
        main: formatter.format(main),
        addons: formatter.format(addons),
        subtotal: formatter.format(subtotal),
        vat: formatter.format(vat),
        total: formatter.format(total),
      };
    },
  },
  created() {
    this.getProduct();
  },
};
</script>

<style scoped>
.error_message {
  font-size: 12px;
  color: #d00000;
}
</style>